import React from 'react';
import FundingPageHeader from './FundingPageHeader';
import FundingPipelineRibbon from './FundingPipelineRibbon';

const FundingSectionPage = ({
  title,
  subtitle,
  eyebrow = 'FundGenius HQ',
  activeStage,
  actions,
  children,
}) => (
  <div data-testid="funding-section-page">
    <FundingPageHeader
      eyebrow={eyebrow}
      title={title}
      subtitle={subtitle}
      actions={actions}
    />
    {activeStage ? <FundingPipelineRibbon activeStage={activeStage} /> : null}
    {children}
  </div>
);

export default FundingSectionPage;
